import { defineStore } from 'pinia';
import type { IPostCategory, IDetailPost, IPost } from '~/modules/infoPages/types';

export const useInfoPageStore = defineStore('infoPagesStore', () => {
  /**
   * Флаг, указывающий, открыт ли нижний лист.
   * @type {boolean}
   */
  const isBottomSheetOpen = ref(false);

  const detailPosts = reactive<Record<number, IDetailPost>>({});

  const sectionsData = reactive<Record<number, {
    items: IPost[];
    count: number;
  }>>({});

  return {
    isBottomSheetOpen,
    sectionsData,
    detailPosts,
  };
});
